
export default {
    props: {
        value: {
            type: Object,
            default: () => ({})
        },
    }
}
